import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80e538ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Storage", -1))
const _hoisted_2 = { class: "stats row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-4" }, "Projects", -1))
const _hoisted_4 = { class: "row" }

import {reactive, onMounted} from "vue";
import UploadIcon from "@/assets/stats-upload.svg";
import StorageIcon from "@/assets/stats-storage.svg";
import ProcessedStorageIcon from "@/assets/stats-processed-storage.svg";
import TempStorageIcon from "@/assets/stats-temp-storage.svg";
import DashboardLayout from "@/views/layouts/DashboardLayout.vue";
import StatsWidget from "../../components/Pages/Dashboard/StatsWidget.vue";
import DashboardTable from "@/components/Pages/Dashboard/DashboardTable.vue";
import { useDataStore } from "@/store/data-store";
import { Utils } from "@/classes/utils/utils";
import { ProjectQueryInputSortOrderEnum, ProjectQueryInputSortPropertyEnum, StorageInfoData } from "@/swagger";
import PreviewPage from "../PreviewPage.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsAndStoragePage',
  setup(__props) {

const dataStore = useDataStore();
const route = useRoute();

const data = reactive({
	storageInfo: null as StorageInfoData,
	projectTableColumns: ["Name", "User", "Date of creation", "Last updated", "Surveys", "Upload size", "Processed size"],
	projectTableData: [],
	projectsPerPage: 20,
	currentPage: 0,
	pageCount: 1,
	searchString: null as string,
	sortColumns: {
		"2": 0,
		"3": 0,
		"5": 0,
		"6": 0
	}
})

async function loadStorageInfo(){
	data.storageInfo = await dataStore.getStorageInfo();
}

function onProjectsSearch(searchString: string){
	data.searchString = searchString;
	data.currentPage = 0;
	refreshProjects();
}

function onPageChanged(newPage: number){
	data.currentPage = newPage;
	refreshProjects();
}

function onSortChanged(columnIndex: number, order: number){
	//Reset all filters
	for(var column in data.sortColumns){
		data.sortColumns[column] = 0;
	}
	data.sortColumns[columnIndex.toString()] = order;
	refreshProjects();
}

function getCurrentSortProperty(): ProjectQueryInputSortPropertyEnum | undefined{
	if(data.sortColumns["2"] !== 0){
		return ProjectQueryInputSortPropertyEnum.CreatedDate;
	}else if(data.sortColumns["3"] !== 0){
		return ProjectQueryInputSortPropertyEnum.LastUpdateSort;
	}else if(data.sortColumns["5"] !== 0){
		return ProjectQueryInputSortPropertyEnum.UploadSizeSort;
	}else if(data.sortColumns["6"] !== 0){
		return ProjectQueryInputSortPropertyEnum.ProcessedSizeSort;
	}else{
		return undefined;
	}
}

function getSortOrder(property: ProjectQueryInputSortPropertyEnum): ProjectQueryInputSortOrderEnum | undefined{
	let order: number | undefined = undefined;

	switch(property){
		case ProjectQueryInputSortPropertyEnum.CreatedDate:
			order = data.sortColumns["2"];
			break;
		case ProjectQueryInputSortPropertyEnum.LastUpdateSort:
			order = data.sortColumns["3"];
			break;
		case ProjectQueryInputSortPropertyEnum.UploadSizeSort:
			order = data.sortColumns["5"];
			break;
		case ProjectQueryInputSortPropertyEnum.ProcessedSizeSort:
			order = data.sortColumns["6"];
			break;
	}
	
	return order < 0 ? ProjectQueryInputSortOrderEnum.Asc : (order > 0 ? ProjectQueryInputSortOrderEnum.Desc : undefined);
}

async function refreshProjects(){
	const sortProperty = getCurrentSortProperty();
	var dashboardProjectsData = await dataStore.getDashboardProjects({
		searchString: data.searchString,
		offset: data.currentPage * data.projectsPerPage,
		limit: data.projectsPerPage,
		sortProperty: sortProperty,
		sortOrder: getSortOrder(sortProperty),
	});
	data.projectTableData = dashboardProjectsData.data.map((i)=>[i.projectName,i.userEmail,Utils.formatDate(i.createdDate), Utils.formatDateTime(i.lastUpdateDate),i.surveyCount,Utils.formatBytes(i.uploadSize),Utils.formatBytes(i.processedSize)]);
	data.pageCount = Math.ceil(dashboardProjectsData.totalCount/data.projectsPerPage);
}

onMounted(()=>{
	data.searchString = route.query.searchString as string;
	if(route.query.sortProperty==ProjectQueryInputSortPropertyEnum.CreatedDate){
		data.sortColumns[2] = 1;
	}
	
    loadStorageInfo();
    refreshProjects();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardLayout, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(StatsWidget, {
          class: "col mt-4",
          icon: _unref(StorageIcon),
          value: _unref(Utils).formatBytes(data.storageInfo?.totalStorage),
          description: "Total storage"
        }, null, 8, ["icon", "value"]),
        _createVNode(StatsWidget, {
          class: "col mt-4",
          icon: _unref(UploadIcon),
          value: _unref(Utils).formatBytes(data.storageInfo?.uploadStorage),
          description: "Upload storage"
        }, null, 8, ["icon", "value"]),
        _createVNode(StatsWidget, {
          class: "col mt-4",
          icon: _unref(ProcessedStorageIcon),
          value: _unref(Utils).formatBytes(data.storageInfo?.processedStorage),
          description: "Processed size"
        }, null, 8, ["icon", "value"]),
        _createVNode(StatsWidget, {
          class: "col mt-4",
          icon: _unref(TempStorageIcon),
          value: _unref(Utils).formatBytes(data.storageInfo?.tempFolderSize),
          description: "Temp folder size"
        }, null, 8, ["icon", "value"])
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DashboardTable, {
          class: "mt--50",
          columns: data.projectTableColumns,
          "search-string": data.searchString,
          "sortable-columns": data.sortColumns,
          data: data.projectTableData,
          "current-page": data.currentPage,
          "page-count": data.pageCount,
          "show-search": true,
          onOnSearch: onProjectsSearch,
          onOnPageChanged: onPageChanged,
          onOnSortChanged: onSortChanged
        }, null, 8, ["columns", "search-string", "sortable-columns", "data", "current-page", "page-count"])
      ])
    ]),
    _: 1
  }))
}
}

})